/** Private discovery follows the verified account binding and the World log. */
import type { AnyDocumentId, Repo } from '@automerge/automerge-repo/slim'
import { useRepo } from '@automerge/automerge-repo-react-hooks'
import {
  privateSessionWorldId,
  subscribePrivateSessionCatalog,
  usesPrivateSessionCatalog,
  type WorldDoc,
} from '@mod/core/model'
import { useCallback, useSyncExternalStore } from 'react'
import { useDocument } from '../world/repo/useDocument'

export function usePrivateSessions() {
  const repo = useRepo() as unknown as Repo
  const subscribe = useCallback(
    (listener: () => void) => subscribePrivateSessionCatalog(repo, listener),
    [repo],
  )
  const snapshot = useCallback(() => privateSessionWorldId(repo), [repo])
  const worldId = useSyncExternalStore(subscribe, snapshot, snapshot)
  const [world] = useDocument<WorldDoc>(worldId as AnyDocumentId | undefined)
  return {
    enabled: usesPrivateSessionCatalog(repo),
    loading: !world,
    entries: world?.privateSessions,
    /** RFC 0345 3c: sessions other people shared with this person. */
    shared: world?.sharedWithMe,
  }
}
